import styled from "styled-components"
import { 
    // COLOR,
    // FONT
 } from 'assets'
 
export const WheelsProfileContainerStyled = styled.div`
/*===============================================
 Container 
===============================================*/
    
/*===============================================
Theme 
===============================================*/
  
`